import React, {Component} from 'react'
import Dropzone from 'react-dropzone'
import './style.css'
import PropTypes from 'prop-types'

class UploadDropzone extends Component {

    render() {

        const {
            onDrop,
            ...props
        } = this.props

        return (
            <Dropzone
                accept="image/jpeg, image/png"
                onDrop={onDrop}

                {...props}

            >
                {({isDragActive, isDragReject}) => {
                    if (isDragActive) {
                        return <h4>Arquivo Válido</h4>
                    }
                    if (isDragReject) {
                        return <h4>Arquivo Inválido</h4>
                    }
                    return (
                        <div style={{textAlign: 'center', color: '#CECECE'}}>
                            <h4>Clique aqui para enviar arquivos</h4> <br/>
                            <h4>ou</h4> <br/> <h4> arraste seus arquivos para cá.</h4>
                        </div>
                    )
                }}
            </Dropzone>
        )
    }
}

UploadDropzone.propTypes = {
    onDrop: PropTypes.func.isRequired
}

export default UploadDropzone



// WEBPACK FOOTER //
// ./src/components/_common/form/FormInput/UploadDropzone/index.js